export const DATE_FROM_LABEL = 'Datum von';
export const DATE_TO_LABEL = 'Datum bis';
export const TIME_FROM_LABEL = 'Uhrzeit von';
export const TIME_TO_LABEL = 'Uhrzeit bis';
export const SEARCH_PLACEHOLDER = 'Suchbegriff eingeben...';
export const APPPOINTMENT_DATA_CARD_TITLE_LABEL = 'Termindaten';
export const LOCATION_LABEL = 'Standort';
export const CUSTOMER_LABEL = 'Kunde';
export const SALES_ITEM_MEDIA_LABEL = 'Fotos und Medien zum Vorgang';
export const CUSTOMER_MEDIA_LABEL = 'Fotos und Medien zum Kunden';
export const LOCATION_MEDIA_LABEL = 'Fotos und Medien zum Standort';
export const BOOK_INVOICE_WARN_TITLE_LABEL = 'Warnung beim Buchen der Rechnung';
export const PROCEED_LABEL = 'Möchten Sie trotzdem fortfahren?';
export const FINISH_TASK_WARN_TITLE_LABEL =
  'Warnung beim Abschließen des Auftrags';
export const BOOK_INVOICE_LABEL = 'Buche Rechnung...';
export const DOCUMENT_NUMBER_LABEL = 'Belegnummer';
export const NAME_LABEL = 'Name';
export const DESCRIPTION_LABEL = 'Beschreibung';
export const PAYMENT_METHOD_LABEL = 'Zahlungsart';
export const APPOINTMENT_DATA_LABEL = 'Termindaten';
export const TASK_DATA_LABEL = 'Auftragsdaten';
export const OFFER_DATA_LABEL = 'Angebotsdaten';
export const INVOICE_DATA_LABEL = 'Rechnungsdaten';
export const AUTOMATICALLY_LABEL = '<automatisch>';
export const CREATED_AT_LABEL = 'Erstellt am';
export const LAST_CHANGED_LABEL = 'Zuletzt geändert am';
export const DETAILS_LABEL = 'Details';
export const MEDIA_LABEL = 'Medien';
export const CUSTOMER_SIGNATURE_LABEL = 'Unterschrift Kunde';
export const MECHANIC_SIGNATURE_LABEL = 'Unterschrift Monteur';
export const FINISH_TASK_LABEL = 'Auftrag abschließen';
export const BOOK_INVOICE_BUTTON_LABEL = 'Rechnung buchen';
export const BOOK_INVOICE_SAVING_ITEMS_TOOLTIP_LABEL =
  'Positionen werden noch gespeichert...';
export const BOOK_INVOICE_ERROR_TITLE_LABEL = 'Buchen fehlgeschlagen';
export const BOOK_INVOICE_ERROR_TEXT_LABEL =
  'Die Rechnung konnte nicht gebucht werden. Bitte überprüfen Sie Ihre Internetverbindung und versuchen Sie es erneut.';
export const REMOVE_ENTRY_LABEL = 'Eintrag entfernen';
export const REMOVE_ENTRY_TEXT_LABEL =
  'Wollen sie den Eintrag wirklich löschen?';
export const NO_ENTRIES_FOUND_LABEL = 'Es wurden keine Einträge gefunden.';
export const DELETE_APPOINTMENT_LABEL = 'Termin löschen';
export const DELETE_APPOINTMENT_TEXT_LABEL =
  'Wollen sie den Termin wirklich löschen?';
export const DELETE_TASK_LABEL = 'Auftrag löschen';
export const DELETE_TASK_TEXT_LABEL =
  'Wollen sie den Auftrag wirklich löschen?';
export const DELETE_OFFER_LABEL = 'Angebot löschen';
export const DELETE_OFFER_TEXT_LABEL =
  'Wollen sie das Angebot wirklich löschen?';
export const DELETE_INVOICE_LABEL = 'Rechnung löschen';
export const DELETE_INVOICE_TEXT_LABEL =
  'Wollen sie die Rechnung wirklich löschen?';
export const PRINT_APPOINTMENT_LABEL = 'Terminbestätigung drucken';
export const PRINT_TASK_LABEL = 'Auftrag drucken';
export const PRINT_OFFER_LABEL = 'Angebot drucken';
export const PRINT_INVOICE_LABEL = 'Rechnung drucken';
export const CONVERT_TASK = 'Auftrag umwandeln';
export const CONVERT_OFFER = 'Angebot umwandeln';
export const CONVERT_TO_INVOICE = 'Rechnung umwandeln';
export const DOWNLOAD_DOCUMENT_LABEL = 'Dokument herunterladen';
export const CANCEL_INVOICE_LABEL = 'Rechnung stornieren';
export const CHOOSE_SALES_TYPE_LABEL = 'Vorgangsart auswählen';
export const TASK_LABEL = 'Auftrag';
export const OFFER_LABEL = 'Angebot';
export const INVOICE_LABEL = 'Rechnung';
export const CANCEL_LABEL = 'Abbrechen';
export const YES_LABEL = 'Ja';
export const CALENDAR_PAGE_TITLE_LABEL = 'Kalender';
export const CALENDAR_PAGE_SUBTITLE_LABEL = 'Alle Termine auf einen Blick';
export const NEW_APPOINTMENT_BUTTON_LABEL = 'Neuer Termin';
export const NEW_TASK_APPOINTMENT_BUTTON_LABEL = 'Neuer Auftrag mit Termin';
export const INVOICE_PAGE_TITLE_LABEL = 'Rechnung';
export const INVOICE_PAGE_SUBTITLE_LABEL = 'Alle Rechnungen auf einen Blick';
export const OPEN_INVOICES_TAB_LABEL = 'Offen';
export const BOOKED_INVOICES_TAB_LABEL = 'Gebucht/Storniert';
export const OFFERS_PAGE_TITLE_LABEL = 'Angebote';
export const OFFERS_PAGE_SUBTITLE_LABEL = 'Alle Angebote auf einen Blick';
export const TASKS_PAGE_TITLE_LABEL = 'Aufträge & Termine';
export const TASKS_PAGE_SUBTITLE_LABEL =
  'Alle Aufträge & Termine auf einen Blick';
export const DASHBOARD_PAGE_TITLE_LABEL = 'Dashboard';
export const DASHBOARD_PAGE_SUBTITLE_LABEL =
  'Alle wichtigen Infos auf einen Blick';
export const TASKS_WITHOUT_APPOINTMENT_LABEL = 'Ohne Termin';
export const APPOINTMENTS_LABEL = 'Mit Termin';
export const CHOOSE_SALES_PAYMENT_TERM_LABEL = 'Zahlungsart auswählen';
export const DASHBOARD_INVOICES_LABEL = 'Rechnungen';
export const DASHBOARD_TASK_LABEL = 'Offene Aufträge';
export const DASHBOARD_CONTACTS_LABEL = 'Kontakte (zuletzt bearbeitet)';
export const DASHBOARD_APPOINTMENTS_LABEL = 'Anstehende Termine';
export const DASHBOARD_CONTACT_HINT = '% des Limits erreicht';
export const DASHBOARD_INVOICE_HINT = ' Rechnungen nicht gebucht';
export const DASHBOARD_TASK_HINT = ' Aufträge offen / in Bearbeitung';
export const DASHBOARD_APPOINTMENTS_HINT = ' Termine in den nächsten 7 Tagen';
